import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import {common} from "../common";

type Props = {
  title: string,
  contentType: string,
  publicLabel?: string,
  productAreas?: string[],
  publishedAt?: string,
  replies: number,
  views: number,
}

const TopicHeader = ({ title, contentType, publicLabel, productAreas, publishedAt, replies, views }: Props) => {
  return (
    <header className='topic__header qa-topic-header'>
      {
        publicLabel ? <span className={`topic__content-type-pill pill pill--uppercase pill--${contentType} qa-content-type-pill`}>
          { publicLabel }
        </span> : null
      }
      <h1 className='h3 topic__title qa-thread-title'>{title}</h1>
      {
        productAreas ? productAreas.length > 0 && <div className='m-v-S'>
          <span className='text--meta'>
            <Phrase p='product.areas.related.products'/>
          </span>
          {
            productAreas.map((productArea: any) =>
              <span className='text--dot-underline product-area-item'> {productArea.name as string} </span>
            )
          }
        </div> : null
      }
      <ul className='list list--dot-seperated text--meta m-v-S qa-topic-meta'>
        <li>
          {
            publishedAt
              ? common.relativeDate(new Date(publishedAt).getTime())
              : <Phrase p='topic.meta.not_published' />
          }
        </li>
        <li className='qa-link-to-replies'>
          <Phrase m='Forum' p='topic.meta.reply' count={{ n: replies.toString() }} />
        </li>
        <li className='is-hidden-S qa-count-views'>
          <Phrase m='Forum' p='topic.meta.views' count={{ n: views.toString() }} />
        </li>
      </ul>
    </header>
  )
}

export default TopicHeader
